import styled from 'styled-components6';

export const CarouselContrast = 'rgba(0, 0, 0, 0.75)';

const CarouselCountContainer = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: ${CarouselContrast};
    border-radius: var(--rwl-radius-sm);
    display: inline-flex;
    height: 20px;
    padding: var(--rwl-spacing-md);
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    color: var(--rwl-palette-white);
    margin: calc(1.5 * var(--rwl-spacing-sm));
    font-weight: 600;
`;

type CarouselCountsProps = {
    totalImages: number;
    currentImageIndex: number;
};

export const CarouselCounts = ({
    totalImages,
    currentImageIndex,
}: CarouselCountsProps): JSX.Element => (
    <CarouselCountContainer className="carousel-count">
        {currentImageIndex + 1} / {totalImages}
    </CarouselCountContainer>
);
